/* eslint-disable no-unused-vars */
import AzureFileuploadHelper from "../../../utils/azureFileuploadHelper";
import { put, call, takeEvery, delay, takeLatest } from "redux-saga/effects";
import { eventChannel, END } from "redux-saga";
import i18n from "i18next";

import * as fileUploadActions from "../actions/fileUploadActions";
import * as documentActions from "../actions/documentActions";
import * as actionsLoader from "../actions/loaderActions";
import * as zoneActions from "../actions/zoneActions";
import * as actionTypes from "../actions/actionTypes";
import * as UtilsHelper from "../../../utils/utilsHelper";
import * as FileUploadService from "../../secure/services/fileuploadService";
import APP_CONST from "../../core/shared/constants";
import { StorageHelper } from "../../../utils/storageHelper";
import _ from "underscore";

export function* downloadFileUrl(data) {
  const { payload, isDialog, DocDetail } = data;
  let { requestPaylod, downloadInfo } = payload;
  let validFilename = UtilsHelper.fileInvalidCharsRemoval(
    downloadInfo.downloadFileName
  );
  if (validFilename.endsWith("." + (data?.tmpFileGuid ? UtilsHelper.getFileExtension(data?.originalFileName) : downloadInfo.type)) === true) {
    requestPaylod.friendlyfilename = `${validFilename}`;
  } else {
    requestPaylod.friendlyfilename = `${validFilename}.${downloadInfo.type}`;
  }
  if(data?.tmpFileGuid && data?.originalFileName){
    requestPaylod.fileguid = data?.tmpFileGuid;
    requestPaylod.originalfilename = data?.originalFileName
  }
  try {
    // yield put(actionsLoader.showLoader());
    const response = data.category
      ? yield FileUploadService.dodownloadDropzoneFileUrl(requestPaylod)
      : yield FileUploadService.doDownloadFileUrl(requestPaylod);
    if (!response.data.isError) {
      const { result } = response.data;
      yield put(
        fileUploadActions.fileDownloadUrlSuccess(result, requestPaylod.fileguid)
      );
      let fileurl = atob(result.sastoken);
      let downFileResponse = yield AzureFileuploadHelper.downloadAzureFile(
        fileurl,
        downloadInfo
      );
      if (!data.category) {
        const historyPayload = {
          documentid: requestPaylod.documentid,
          lastModifiedOn: requestPaylod?.lastmodifiedon ? requestPaylod?.lastmodifiedon : DocDetail?.createdon,
          documentversionguid: requestPaylod.documentversionguid,
        }
        yield put(documentActions.getDocumentHistory(historyPayload));
      }

      if (downFileResponse === undefined) {
        yield put(actionsLoader.hideLoader());
      } else if (!downFileResponse.ok) {
        yield put(actionsLoader.hideLoader());
        if (isDialog) {
          yield put(
            fileUploadActions.fileDownloadurlDialogFailed(
              i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")
            )
          );
        } else {
          yield put(
            actionsLoader.showError(
              `${i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")} - ` +
              downFileResponse.statusText, "error", "warning"
            )
          );
          yield put(
            fileUploadActions.fileDownloadUrlFailed(requestPaylod.documentid)
          );
        }
      }
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      if (isDialog) {
        yield put(
          fileUploadActions.fileDownloadurlDialogFailed(
            `${i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")} - ` + errorMessage
          )
        );
      } else {
        yield put(
          fileUploadActions.fileDownloadUrlFailed(requestPaylod.documentid)
        );
        yield put(
          actionsLoader.showError(
            `${i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")} - ` + errorMessage, "error", "warning"
          )
        );
      }
      yield put(actionsLoader.hideLoader());

    }
  } catch (error) {
    yield put(actionsLoader.hideLoader());
    if (isDialog) {
      yield put(
        fileUploadActions.fileDownloadurlDialogFailed(
          i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")
        )
      );
    } else {
      yield put(
        fileUploadActions.fileDownloadUrlFailed(requestPaylod.documentid)
      );
      yield put(
        actionsLoader.showError(i18n.t("TMF.TOAST_FILEDOWNLOADFAILED"), "error", "warning")
      );
    }
  }
}

function createUploader(file, guid) {
  let emit;
  const chan = eventChannel((emitter) => {
    emit = emitter;
    return () => { };
  });
  emit(0);
  const uploadProgressCb = (ev) => {
    const percentage = Math.round((ev.loadedBytes * 100) / file.size);
    emit(percentage);
    if (percentage > 100) emit(END);
  };
  const dummyUploadProgressCb = (ev) => {
    let percentage = Math.round((ev.loadedBytes * 100) / file.size);
    for (let i = 0; i <= 10; i++) {
      percentage = i * 10;
      emit(percentage);
    }
    if (percentage > 100) emit(END);
  };
  let uploadPromise = null;
  if (file.size >= APP_CONST.FILE_SIZE.TENMB) {
    uploadPromise = AzureFileuploadHelper.uploadFiles(
      file,
      guid,
      uploadProgressCb
    );
  } else {
    uploadPromise = AzureFileuploadHelper.uploadFiles(
      file,
      guid,
      dummyUploadProgressCb
    );
  }
  return [uploadPromise, chan];
}

export function* uploadFile(data) {
  const { filePassPayload, guid, viewPerPageCount } = data.payload;
  const { docItem } = filePassPayload;
  try {
    const [uploadPromise, chan] = yield call(
      createUploader,
      filePassPayload.files,
      guid
    );
    // yield fork(watchUploadProgresssChannel, chan, guid);
    const res = yield call(() => uploadPromise);
    if (res.errorCode === undefined) {
      docItem.azureStorageResponse = JSON.stringify(res);
      const response = yield FileUploadService.doPassDocdetails(docItem);
      if (!response.data.isError) {
        const fileDetails = response.data.result;
        let docContent = fileDetails.documentcontents
          ? JSON.parse(fileDetails.documentcontents)
          : { documentDetails: {} };
        yield put(
          fileUploadActions.scanningProcessStatus(
            guid,
            docItem.origiartifactid,
            {
              ...docContent.documentDetails,
              uploadingProgress: UtilsHelper.randomNumber([24, 32, 40]),
            },
            viewPerPageCount
          )
        );
        yield put(fileUploadActions.fileUploadSuccess(response.data.result));
      } else {
        const errorMessage = UtilsHelper.constructErrorMsg(response.data);
        if (errorMessage === "File upload cancelled") {
          const { documentContents } = docItem;
          let docContent = documentContents
            ? JSON.parse(documentContents)
            : { documentDetails: {} };
          yield put(
            fileUploadActions.fileUploadProgress({
              docObject: {
                ...docContent.documentDetails,
                uploadingProgress: 7,
              },
            })
          );
        } else {
          yield put(
            fileUploadActions.fileUploadFailed({ ...docItem, errorMessage })
          );
        }
      }
    }
  } catch (e) {
    yield put(actionsLoader.showError(i18n.t("TMF.TOAST_FILEUPLOADFAILED"), "error", "warning"));
    yield put(fileUploadActions.fileUploadFailed({ ...docItem, errorMessage: e.message }));
  }
}

export function* cancelUpload(data) {
  try {
    const response = yield FileUploadService.doCancelUpload(data.payload);
    yield put({ type: "CANCEL_UPLOAD_DATA", payload: response.data.result });
  } catch (error) { }
}

export function* scanningStatusSaga(data) {
  const { id, from, docObject, viewPerPageCount } = data.payload;
  try {
    const response = yield FileUploadService.doScanningStatus(id);
    if (!response.data.isError) {
      const {
        isscancompleted,
        scanresult,
        id,
        tmfdocumentid,
        documentstage,
        documentversionnumber,
        documentversionguid,
      } = response.data.result;
      const { uploadingProgress } = docObject;
      let newUploadingProgress =
        uploadingProgress <= 100
          ? uploadingProgress + UtilsHelper.randomNumber([6, 7, 8])
          : uploadingProgress;
      const newDocObject = {
        ...docObject,
        uploadingProgress: newUploadingProgress,
        documentversionnumber: documentversionnumber,
        documentversionguid: documentversionguid,
      };
      let uploadProgressObj = {
        id,
        tmfdocumentid,
        artifactId: from,
        docObject: newDocObject,
      };
      const scanInfo = JSON.parse(scanresult);
      if (from !== "DocForm") {
        if (isscancompleted) {
          if (documentstage === "cancelled") {
          } else if (scanInfo.Success) {
            const resultObj = {
              ...response.data.result,
              artifactId: from,
              docObject: { ...newDocObject, uploadingProgress: 99 },
            };
            yield put(
              fileUploadActions.fileUploadProgress({
                ...uploadProgressObj,
                docObject: { ...newDocObject, uploadingProgress: 99 },
              })
            );
            yield delay(5000);
            yield put(
              fileUploadActions.scanningProcessStatusSuccess(resultObj)
            );
            yield put(zoneActions.removeInvalidDocument(false));
            let lastdocumentupdatedon = sessionStorage.getItem(
              "lastdocumentupdatedon"
            );
            let req = {
              searchKey: "",
              site: "ALL",
              countryCode: "ALL",
              pageCount: 0,
              pageSize: viewPerPageCount || 20000,
              pageNumber: 1,
              artifactId: "",
              sectionid: "",
              category: "",
              milestoneGroup: "ALL",
              milestoneId: "",
              lastdocumentupdatedon: lastdocumentupdatedon,
            };

            let recentSearchInfo = StorageHelper.getRecentSearchInfo();
            if (!_.isEmpty(recentSearchInfo)) {
              StorageHelper.setRecentSearchInfo(recentSearchInfo);
            } else {
              StorageHelper.setRecentSearchInfo(req);
            }
            yield put(zoneActions.fetchMetricsData());
            let isFileScan = StorageHelper.getIsAGGridApiRunning();
            if (isFileScan === "false") {
              StorageHelper.setIsAGGridApiRunning(true);
              yield put({ type: "AGGRID_GET_CALL", payload: req });
            }
          } else {
            const resultObj = { ...response.data.result, artifactId: from };
            yield put(
              fileUploadActions.fileUploadProgress({
                ...uploadProgressObj,
                docObject: { ...newDocObject, uploadingProgress: 100 },
              })
            );
            yield delay(1000);
            yield put(fileUploadActions.scanningProcessStatusFailed(resultObj));
          }
        } else {
          if (documentstage !== "cancelled") {
            if (newUploadingProgress <= 96)
              yield put(
                fileUploadActions.fileUploadProgress(uploadProgressObj)
              );
            yield delay(3000);
            yield put(
              fileUploadActions.scanningProcessStatus(id, from, newDocObject)
            );
          }
        }
      } else {
        if (isscancompleted) {
          if (documentstage === "cancelled") {
            yield put(fileUploadActions.singleFileProgressing({ id: "" }));
          } else {
            yield put(
              fileUploadActions.singleFileProgressing({
                id,
                uploadingProgress: 99,
              })
            );
            yield delay(1000);
            yield put(
              fileUploadActions.createNewDocVersionSuccess({
                id,
                isscancompleted,
              })
            );
            yield put(zoneActions.isUploadedNewVersionFile(true));
            if (!scanInfo.Success) {
              yield put(actionsLoader.showError(
                i18n.t("TMF.TOAST_FILECONTAINVIRUSMESSAGE"), "error", "warning"
              ));

              yield put(fileUploadActions.createNewDocVersionFailed());
              yield put(zoneActions.isUploadedNewVersionFile(false));
            }
          }
        } else {
          if (documentstage !== "cancelled") {
            yield put(fileUploadActions.singleFileProgressing());
            yield delay(3000);
            yield put(fileUploadActions.scanningProcessStatus(id, from, {}));
          }
        }
      }
    } else {
      yield put(fileUploadActions.scanningProcessStatusFailed());
    }
  } catch (error) {
    if (from !== "DocForm") {
      yield put(actionsLoader.showError(i18n.t("TMF.TOAST_FILEUPLOADFAILED"), "error", "warning"));
    } else {
      yield put(
        fileUploadActions.fileDownloadurlDialogFailed(
          i18n.t("TMF.TOAST_FILEUPLOADFAILED")
        )
      );
    }
  }
}

export function* filePreviewSaga(data) {
  try {
    let requestPayload = {
      documentid: data.payload.requestPaylod.documentid,
      fileguid: data.payload.requestPaylod.fileguid,
      lastmodifiedon: data.payload.requestPaylod.lastmodifiedon,
      isDropZoneFile: data.isDropzone,
      isPreviewAudit: data.isPreviewAudit,
      friendlyfilename: data.payload.downloadInfo.downloadFileName,
      documentversionguid: data.versionId,
    };
    let fileName = data.payload.downloadInfo.downloadFileName;
    let fileType = data.payload.downloadInfo.type;
    if(data?.tmpFileGuid && data?.originalFileName){
      requestPayload.fileguid = data?.tmpFileGuid;
      requestPayload.originalfilename = data?.originalFileName;
    }
    const response = yield FileUploadService.doPreviewFile(requestPayload);
    if (!response.data.isError) {
      const { sastoken } = response.data.result;
      let fileurl = atob(sastoken);
      yield put(
        fileUploadActions.filePreviewUrlSuccess(
          fileurl,
          fileName,
          fileType,
          requestPayload
        )
      );
    } else {
      yield put(fileUploadActions.fileDownloadurlDialogFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
      yield put(fileUploadActions.filePreviewUrlFailed());
    }
  } catch (error) {
    yield put(fileUploadActions.fileDownloadurlDialogFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
    yield put(fileUploadActions.filePreviewUrlFailed());
  }
}

export function* createNewDocVersionSaga(data) {
  try {
    const response = yield FileUploadService.doCreateNewDocVersion(
      data.payload
    );
    if (!response.data.isError) {
      const { isscancompleted, id } = response.data.result;
      yield put(fileUploadActions.createNewDocVersionSuccess({ id, isscancompleted }));
      yield put(fileUploadActions.scanningProcessStatus(id, "DocForm", {}));
    } else {
      yield put(fileUploadActions.createNewDocVersionFailed());
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      if (errorMessage === "File upload cancelled") {
        yield put(
          fileUploadActions.fileDownloadurlDialogFailed(errorMessage)
        );
      }
    }
  } catch (error) {
    yield put(
      fileUploadActions.fileDownloadurlDialogFailed(
        i18n.t("TMF.TOAST_FILEDOWNLOADFAILED")
      )
    );
  }
}

export function* createNewDocVersionCancelSaga(data) {
  try {
    const response = yield FileUploadService.doCancelScanning(data.payload);
    if (!response.data.isError) {
      const { docObject = {} } = data;
      const { isscancompleted } = response.data.result;
      yield put(fileUploadActions.createNewDocVersionSuccess(isscancompleted, "Cancel"));
      const { id, tmfdocumentid } = response.data.result;
      yield put(
        fileUploadActions.fileUploadProgress({
          id,
          tmfdocumentid,
          artifactId: docObject && docObject.origiartifactid,
          docObject: { ...docObject, uploadingProgress: 7 },
        })
      );
    } else {
      yield put(fileUploadActions.createNewDocVersionFailed());
    }
  } catch (error) {
    yield put(
      fileUploadActions.fileDownloadurlDialogFailed(
        i18n.t("ADMIN.TOAST_CREATENEWVERSIONFAILED")
      )
    );
  }
}


export function* watchFileAsync() {
  yield takeEvery(actionTypes.FILE_UPLOAD, uploadFile);
  yield takeEvery(actionTypes.SCANNING_PROCESS_STATUS, scanningStatusSaga);
  yield takeEvery(actionTypes.CANCEL_UPLOAD, cancelUpload);
  yield takeEvery(actionTypes.FILE_DOWNLOAD_URL, downloadFileUrl);
  yield takeLatest(actionTypes.FILE_PREVIEW_URL, filePreviewSaga);

  yield takeEvery(actionTypes.CREATE_NEW_DOC_VERSION, createNewDocVersionSaga);
  yield takeEvery(
    `${actionTypes.CREATE_NEW_DOC_VERSION}_CANCEL`,
    createNewDocVersionCancelSaga
  );
}
